<template>
    <div v-if="showModal" id="order_modal" class="ui center aligned grid">
        <div class="column">
            <div id="header" class="ui top fixed menu">
                <h3>{{ order.partnerName }} 주문 ({{ new Date(order.createdAt).format("yy-MM-dd HH:mm") }})</h3>
            </div>
            <div id="body">
                <table class="ui striped celled compact table">
                    <thead>
                        <tr>
                            <th class="collapsing">#</th>
                            <th class="collapsing">타입</th>
                            <th class="collapsing">주문날짜</th>
                            <th class="collapsing">상품명</th>
                            <th class="collapsing">수량</th>
                            <th class="collapsing">주문자</th>
                            <th class="collapsing">수취인</th>
                            <th>주소</th>
                            <th class="collapsing">센터</th>
                            <th class="collapsing">배송기사</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, index) in order.items" :key="item._id">
                            <td class="collapsing"> {{ index + 1 }} </td>
                            <td class="collapsing"> {{ constantNames[item.type] }} </td>
                            <td class="collapsing"> {{ new Date(item.orderedAt).format("yyyy-MM-dd(KS)") }} </td>
                            <td class="collapsing"> {{ item.product }} </td>
                            <td class="collapsing"> {{ item.count }} </td>
                            <td class="collapsing"> {{ item.orderer }} </td>
                            <td class="collapsing"> {{ item.receiver }} </td>
                            <td> {{ item.address }} </td>
                            <td :class="item._center ? 'collapsing' : 'red collapsing' ">
                                <select class='ui simple dropdown' v-model="item._center" @change="onCenterChange(item)" :disabled="item.type == constant.TYPE_PARCEL">
                                    <option :value="c._id" v-for="c in centers" :key="c._id">{{ c.name }}</option>
                                </select>
                            </td>
                            <td :class="item._worker ? 'collapsing' : 'red collapsing'">
                                <select class='ui simple dropdown' v-model="item._worker" @change="onWorkerChange">
                                    <option :value="worker._id" v-for="worker in getWorkers(item._center)" :key="worker._id">
                                        {{ worker.name }}
                                    </option>
                                </select>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div id="footer" class="ui bottom fixed menu">
                <div class="right menu">
                    <div v-if="errorCount<=0" class="ui primary left labeled icon button" @click="onConfirmClick">
                        <i class="checkmark icon"></i>
                        <span>{{ "확정" }}</span>
                    </div>
                    <div v-if="errorCount>0" class="ui negative left labeled icon button" @click="onConfirmClick">
                        <i class="bug icon"></i>
                        <span>{{ "에러 " + errorCount }}</span>
                    </div>
                    <div class="ui button" @click="close">닫기</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    data: function() {
        return {
            showModal: 0, order: 0, errorCount: 0, onChange: 0,
        }
    },
    created: function() {
        this.showModal = false;
        this.$event.set("openConfirmOrder", this.open);
    },
    mounted: function() {
        window.addEventListener('keyup', (e) => { if (this.showModal && e.keyCode === 27) this.close(); });
    },
    destroyed: function() {
        this.$event.clear("openConfirmOrder");
    },
    methods: {
        open(order, onChange) {
            if (order && order.items) {
                this.showModal = true;
                this.order = order;
                this.errorCount = 0;
                this.onChange = onChange;

                for (var item of order.items) {
                    const center = this.findCenter(item);
                    if (center) {
                        item._center = center._id;
                        const worker = this.findWorker(item, center);
                        item._worker = (worker) ? worker._id : "";
                    }
                }
                this.checkValidate();
            }
        },
        close() {
            this.showModal = false;
        },
        checkValidate() {
            this.errorCount = 0;
            for (var item of this.order.items) {
                if (item.type != this.constant.TYPE_PARCEL) {
                    if (!item._center || !item._worker) { this.errorCount += 1; }
                }
            }
            this.$forceUpdate();
            return this.errorCount <= 0;
        },
        onCenterChange(item) {
            item._worker = "";
            this.checkValidate();
        },
        onWorkerChange() {
            this.checkValidate();
        },
        onConfirmClick() {
            if (this.checkValidate()) {

                const items = [];
                for (var item of this.order.items) {
                    items.push({
                        trackingNumber: item.trackingNumber,
                        _worker: item._worker,
                        _center: item._center,
                    });
                }

                this.$event.call("openLoading");
                this.$api.confirmOrder(this.user._id, this.order._id, items, (resData) => {
                    this.$event.call("closeLoading");
                    if (resData.error){
                        alert(resData.error.message);
                    } else {
                        this.close();
                        if (this.onChange) this.onChange();
                    }
                });
            }
        },
        findCenter(item) {
            for (var center of this.centers) {
                if (center.regions && center.regions[item.region1])
                {
                    const worker = this.findWorker(item, center);
                    if (worker) return center;
                }
            }
            return undefined;
        },
        findWorker(item, center) {
            for (const worker of this.workers) {
                if (worker._center == center._id && worker.position == "배송기사") {
                    if (worker.regions && worker.regions[item.region1] && worker.regions[item.region1].includes(item.region2)) {
                        return worker;
                    }
                }
            }
            return undefined;
        },
        getWorkers(_centerId) {
            const array = [];
            for (const worker of this.workers) {
                if (worker.position == "배송기사" && worker._center == _centerId) {
                    array.push(worker);
                }
            }
            return array;
        },
    },
    computed: {
        region2Options: function() { return this.$store.getters.region2Options; },
        user: function() { return this.$store.getters.user; },
        partners: function() { return this.$store.getters.partners; },
        constant: function() {return this.$store.getters.constant; },
        constantNames: function() { return this.$store.getters.constantNames; },
        centers: function() { return this.$store.getters.centers; },
        workers: function() { return this.$store.getters.workers; },
    },
}
</script>

<style>
#order_modal {
    position: fixed;
    left: 0;
    top: 0;
    margin: 0;
    z-index: 1;
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: #fff;
}

#order_modal .column {
    max-width: 1300px;
}

#order_modal #header {
    padding: 20px 30px;
}

#order_modal #body {
    margin: 80px 0;
    width: 100%;
    font-size: 12px;
    overflow: auto;
}

#order_modal #header {
    padding: 20px 30px;
}

#order_modal #footer {
    padding: 20px 30px;
    background-color: #eee;
}

#order_modal .ui.form {
    padding: 30px;
}
</style>


// WEBPACK FOOTER //
// src/components/OrderModal_Confirm.vue